// Added by Sejune Oh on 2020-04-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    TableRow as MaterialUITableRow,
    TableRowProps as MaterialUITableRowProps
} from '@material-ui/core'

interface TableRowBaseProps { }
export type TableRowProps = Partial<MaterialUITableRowProps> & TableRowBaseProps

export const TableRow: FC<TableRowProps> = ({ ...props }) => {
    return <MaterialUITableRow {...props}></MaterialUITableRow>
}
